import { defineStore } from 'pinia'
import { watch, ref, toValue, computed } from 'vue'
import { omit, pick } from 'lodash-es'
import { useRoute, useRouter } from 'vue-router'

const model = ['page', 'onPage', 'search', 'order_direction', 'order_field', 'filter', 'filter_id']

export const useListStore = defineStore('list', () => {
  const router = useRouter()
  const route = useRoute()

  let startValue = pick(route.query, model)
  if (Object.keys(startValue).length) {
    startValue = { [route.name]: startValue }
  } else {
    startValue = {}
  }

  const history = ref(startValue)
  const historyItem = computed(() => history.value[route.name])

  router.beforeResolve((to, _, next) => {
    const hst = history.value[to.name]
    if (!hst) {
      next()
      return
    }
    if (Object.keys(hst).every(q => to.query[q] == hst[q])) {
      next()
      return
    }
    next({ ...to, query: { ...to.query, ...hst } })
  })

  watch(history, h => {
    for (const [p, q] of Object.entries(h)) {
      if (route.name !== p) {
        continue
      }
      fromHistoryToRoute(q)
      break
    }
  })

  function save(v) {
    const val = { ...history }
    if (v === undefined) {
      delete val[route.name]
    } else {
      val[route.name] = toValue(v)
    }
    history.value = val
  }

  function fromHistoryToRoute(q) {
    const query = omit(route.query, model)
    Object.assign(query, q)
    router.push({ ...route, query })
  }

  return {
    history,
    historyItem,
    save,
  }
})
